const message = () =>
    import('@/views/system/message/index.vue');
const keyWord = () =>
    import('@/views/system/keyWord/index.vue');
const ip = () =>
    import('@/views/system/ip/index.vue');

export default [
    {
        path: "/system/message",
        name: "message",
        components: {
            default: message,
        },
        meta: {
            nav: "system",
            navChild: "message",
            navName:"消息管理",
            keepAlive: true
        },
    },
    {
        path: "/system/keyWord",
        name: "keyWord",
        components: {
            default: keyWord,
        },
        meta: {
            nav: "system",
            navChild: "keyWord",
            navName:"过滤词管理",
            keepAlive: true
        },
    },
    {
        path: "/system/ip",
        name: "ip",
        components: {
            default: ip,
        },
        meta: {
            nav: "system",
            navChild: "ip",
            navName:"过滤IP管理",
            keepAlive: true
        },
    },
]



// WEBPACK FOOTER //
// ./src/views/system/index.js